import React from "react"
import DashboardAlertes from "./alertes/_DashboardAlertes"
import DashboardKpi from "./kpi/DashboardKpi"
import { useAuth } from "../../AppContext"
import { CONST_USER_PERMISSION_TDB_INDICATEURS_VIEW } from "@common-constants/*" // Newly imported

const Dashboard = () => {
     const { currentUser } = useAuth()

     return (
          <div className={"d-flex justify-content-center"}>
               <div className={"w-100 w-lg-75 w-xxl-75"}>
                    {/* Top Section: Alerts */}
                    <DashboardAlertes />

                    {/* Middle Section: KPI & Charts */}
                    {currentUser?.permissions?.includes(CONST_USER_PERMISSION_TDB_INDICATEURS_VIEW) && <DashboardKpi />}
               </div>
          </div>
     )
}

export default Dashboard
